exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n\r\ntable.table-productinfo th , table.table-productinfo td  {\r\n    vertical-align:middle;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/product-list/product-list.component.css
// module id = ../../../../../src/app/product-list/product-list.component.css
// module chunks = main